// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3MnYB","showModal":"Modal_showModal__timkb","outer":"Modal_outer__Wocu6","close":"Modal_close__1C309"};